import { parseJson } from '@medicusunion/front-utils';
import dayjs from 'dayjs';

type Params = {
  key: string;
  cacheTimeHours?: number;
};

class CacheWithQuery {
  key: string;
  cacheTimeHours: number;
  constructor(params: Params) {
    this.key = params.key;
    this.cacheTimeHours = params.cacheTimeHours || 24;
  }

  init() {
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith(this.key)) {
        const values = localStorage.getItem(key);

        if (!values) {
          return;
        }

        const data = parseJson(values);

        if (!data) {
          return;
        }

        if (dayjs().diff(dayjs(data.date), 'hours') > this.cacheTimeHours) {
          localStorage.removeItem(key);
        }
      }
    });
  }

  private getDataKey(query: string) {
    return `${this.key}_${query}`;
  }

  setData(query: string, values: Record<string, unknown>) {
    try {
      const data = JSON.stringify({
        values,
        date: dayjs().startOf('day').set('hours', 10)
      });

      localStorage.setItem(this.getDataKey(query), data);
    } catch {
      // do nothing
    }
  }

  getData(query: string) {
    try {
      const key = this.getDataKey(query);

      const values = localStorage.getItem(key);

      if (!values) {
        return null;
      }

      const data = parseJson(values);

      if (!data) {
        return null;
      }

      if (dayjs().diff(dayjs(data.date), 'hours') > this.cacheTimeHours) {
        localStorage.removeItem(key);

        return null;
      }

      return data.values;
    } catch {
      return null;
    }
  }
}

export const analyticsReviewCache = new CacheWithQuery({
  key: 'partner_analytics_review'
});

export const analyticsDynamicsCache = new CacheWithQuery({
  key: 'partner_analytics_dynamics'
});

export const analyticsUtmValuesCache = new CacheWithQuery({
  key: 'partner_analytics_utm_values'
});
